import React from "react";

const ApprovedCases: React.FC = () => {
    return (
        <div>Approved Cases Content</div>
    );
}

export default ApprovedCases;